export var AdminNotificationType;
(function (AdminNotificationType) {
    AdminNotificationType["ORG_ADMIN_ADDED"] = "org_admin_added";
    AdminNotificationType["ORG_ADMIN_REMOVED"] = "org_admin_removed";
    AdminNotificationType["PROJECT_ADMIN_ADDED"] = "project_admin_added";
    AdminNotificationType["PROJECT_ADMIN_REMOVED"] = "project_admin_removed";
    AdminNotificationType["CONNECTION_SETTINGS_CHANGE"] = "connection_settings_change";
})(AdminNotificationType || (AdminNotificationType = {}));
//# sourceMappingURL=adminNotifications.js.map